import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Spinner from '../../components/Spinner/Spinner';
import './LoadingPage.css';
import {tagProcessingPageView} from '../../Services/TaggingService/TaggingService';
import {isOutOfOrder} from '../../utils/functions/Functions';
import {updateHighestPageHit, updateLoadingPageTagged} from '../../redux/app-state-slice';
import {getQueryElement} from '../../utils/queryElement';
import {FormHeaderSection} from '../PrequalSinglePageApp/FormHeaderSection/FormHeaderSection';

function LoadingPage({customerData, dispatch}) {
  const tips = [
    "You're not obligated to finance with us after you receive your prequalification offer.",
    'Your prequalification offer is an estimate based on the information you provided us.',
    'Your dealer may be able to provide better terms after reviewing your prequalification offer',
    'Prequalifications do not affect your credit score.',
    'Prequalification offers are valid for 180 days from the time of application.'
  ];
  const [tipsIndex, setTipsIndex] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    if (!customerData.isDealerHostApplication.value && isOutOfOrder(customerData)) {
      navigate('/');
    }
    const id = setTimeout(() => setTipsIndex((tipsIndex + 1) % tips.length), 5000);
    return () => {
      clearInterval(id);
    };
  }, [tipsIndex]);

  useEffect(() => {
    const queryElement = getQueryElement(customerData);
    queryElement.getElementById('prequal--web--parentLoadingPage').scrollIntoView();
    if (!customerData.loadingPageTagged) {
      tagProcessingPageView(customerData);
      dispatch(updateLoadingPageTagged(true));
    }
    dispatch(updateHighestPageHit(3));
  }, [customerData.loadingPageTagged]);

  return (
    <>
      <div id='prequal--web--form-section' className='prequal--wc--form-section' data-testid='prequal--web--form-section'>
        <FormHeaderSection
          isDealerHostApplication
          dispatch={dispatch}
          customerData={customerData}
          navigate={navigate}
          headerText='Review and submit your info.'
          className='prequal--wc--header-close-container-loading-page'
        />
        <div id='prequal--web--form-section' className='prequal--wc--form-section'>
          <div id='prequal--web--parentLoadingPage' className='prequal--web--fomo-parentLoadingPage' data-testid='loading-page-container'>
            <div className='prequal--web--containerLoadingPage'>
              <div className='prequal--web--fomo-loading-header' data-testid='prequal--web--fomo-loading-header'>
                {' '}
                Just a minute ...
                <span className='prequal--web--mobile-break'>
                  <br />
                </span>{' '}
                We&lsquo;re fetching your decision
              </div>
              <Spinner customerData={customerData} />
              <div className='prequal--web--fomo-spinner-padding' />
              <span className='prequal--web--fomo-loading-tips'> {tips[tipsIndex]} </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoadingPage;
